// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16jlkb7n{flex-grow:1}
._19pkutpp{margin-top:var(--ds-space-150,9pt)}
._1bah1h6o{justify-content:center}
._1e0c1txw{display:flex}
._1tkeys9h{min-height:5pc}
._1wpz1h6o{align-self:center}
._4cvr1h6o{align-items:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-picker/dist/esm/ui/link-picker/search-results/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,kCAAkC;AAC7C,WAAW,sBAAsB;AACjC,WAAW,YAAY;AACvB,WAAW,cAAc;AACzB,WAAW,iBAAiB;AAC5B,WAAW,kBAAkB","sourcesContent":["._16jlkb7n{flex-grow:1}\n._19pkutpp{margin-top:var(--ds-space-150,9pt)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1tkeys9h{min-height:5pc}\n._1wpz1h6o{align-self:center}\n._4cvr1h6o{align-items:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
